import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

let echo = null;

export function initEcho() {
    if (!echo) {
        echo = new Echo({
            broadcaster: "reverb",
            key: "local",
            wsHost: "localhost",
            wsPort: 8080,
            forceTLS: false,
        });
    }

    return echo;
}
